<template>
    <!-- CONTENT-9
    ============================================= -->
    <div id="content-9" class="content-9 bg-snow pt-60 content-section division">
        <div class="container">


            <!-- IMAGE BLOCK -->
            <div class="row">
                <div class="col">
                    <div class="content-9-img video-preview wow fadeInUp">

                        <!-- Play Icon -->
                        <!-- C0UlOD4XAEg -->
                        <a class="video-popup1" href="https://www.youtube.com/embed/C0UlOD4XAEg">
                            <div class="video-btn video-btn-xl bg-green ico-90">
                                <div class="video-block-wrapper"><span class="flaticon-play-button"></span></div>
                            </div>
                        </a>

                        <!-- Preview Image -->
                        <img class="img-fluid" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-dashboard-creditfixrr-sfotware-800.png" alt="video-preview">

                    </div>
                </div>
            </div>


        </div>	   <!-- End container -->
    </div>	<!-- END CONTENT-9 -->
</template>
<script>
    export default{
        name:'LandingVideo',
    }
</script>
